import angular, { IScope } from 'angular';
import { PriceListsCreateModalDatePickerControllerModule } from './PriceListsCreateModalDatePickerController';
import { TODO, UIBModal } from '@b2b/types/core';

PriceListsCreateModalController.$inject = ['$scope', '$uibModalInstance', 'priceLists'];

function PriceListsCreateModalController(
  $scope: IScope & {
    cancel: TODO;
    done: TODO;
    errors: TODO;
    hasErrors: TODO;
    init: TODO;
    isUnique: TODO;
    model: TODO;
    success: TODO;
    trim: TODO;
  },
  $uibModalInstance: UIBModal<TODO>,
  priceLists: TODO
) {
  $scope.errors = [];

  $scope.model = {
    name: '',
    description: '',
    effectiveStartTime: new Date(),
    effectiveEndTime: null,
    priceListType: null,
    prices: [],
  };

  $scope.init = function () {};

  $scope.hasErrors = function () {
    return $scope.errors.length > 0;
  };

  $scope.trim = function (s) {
    return s.replace(/\s+/g, '').toLowerCase();
  };

  $scope.isUnique = function () {
    const trimmedCurrent = $scope.trim($scope.model.name);
    let r = true;

    for (let i = 0, ii = priceLists.length; i < ii; i++) {
      const trimmed = $scope.trim(priceLists[i].name);
      if (trimmedCurrent === trimmed) {
        r = false;
        break;
      }
    }

    return r;
  };

  $scope.done = function () {
    if ($scope.isUnique()) {
      if ($scope.model.name.replace(/\s+/g, '').length > 0) {
        $scope.success();
      } else {
        $scope.errors.push({ message: 'Please enter a valid name' });
      }
    } else {
      $scope.errors.push({ message: 'A price list named "' + $scope.model.name + '" already exists' });
    }
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $uibModalInstance.close($scope.model);
  };

  $scope.init();
}

export const PriceListsCreateModalControllerModule = angular
  .module('acme.view.application.pricing.lists.createModal.controllers', [
    'acme.common.service.userPreferences',
    PriceListsCreateModalDatePickerControllerModule,
  ])
  .controller('PriceListsCreateModalController', PriceListsCreateModalController).name;
